/**
 * Precomputed publication scatter rows from Supabase (`publication_abatement_scatter`).
 * Populated by scripts/populate_publication_abatement_scatter.ts (service role).
 */

import { supabaseClient } from './supabase';
import type { BuildingsBauScenario } from './buildingsBauPathways';

export const PUBLICATION_ABATEMENT_POLICY_PRESET = 'moderate' as const;

export interface PublicationAbatementScatterRow {
  geofips: string;
  location_name: string;
  geography_type: string;
  emfac_version: string;
  buildings_bau_scenario: string;
  policy_preset: string;
  cost_per_ton: number | null;
  abatement_per_capita: number | null;
  cumulative_reduction_mt: number | null;
  population: number | null;
  skip_reason: string | null;
  updated_at: string;
}

/**
 * All rows for one scenario slice (policy preset fixed to moderate in DB).
 */
export async function fetchPublicationAbatementScatterRows(
  emfacVersion: '2021' | '2025',
  buildingsBau: BuildingsBauScenario,
  policyPreset: string = PUBLICATION_ABATEMENT_POLICY_PRESET
): Promise<{ rows: PublicationAbatementScatterRow[]; error: string | null }> {
  const { data, error } = await supabaseClient
    .from('publication_abatement_scatter')
    .select(
      'geofips,location_name,geography_type,emfac_version,buildings_bau_scenario,policy_preset,cost_per_ton,abatement_per_capita,cumulative_reduction_mt,population,skip_reason,updated_at'
    )
    .eq('policy_preset', policyPreset)
    .eq('emfac_version', emfacVersion)
    .eq('buildings_bau_scenario', buildingsBau)
    .order('location_name');

  if (error) {
    return { rows: [], error: error.message };
  }

  return { rows: (data as PublicationAbatementScatterRow[]) ?? [], error: null };
}
